import React from 'react';
import { Box, AppBar, Toolbar, Typography, Container } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import LanguageSelector from '../common/LanguageSelector';
import ThemeSelector from '../common/ThemeSelector';
import SmsCabinetBackButton from '../common/SmsCabinetBackButton';
import { SMS_PAGE, useSmsPageDesign } from '../../theme/smsPageDesign';

const MainLayout: React.FC = () => {
  const { isSmsLight } = useSmsPageDesign();
  const location = useLocation();
  const isEditing = /^\/bot\/chain\//.test(location.pathname);
  const isPreview = /^\/bot\/preview\//.test(location.pathname);
  const isConstructorHome = location.pathname === '/bot';
  const isFullHeight = isEditing || isPreview;
  /** Шапка кабинета: не на главной конструктора /bot — там своя полоса с «назад» и темой. Редактор и предпросмотр — своя шапка страницы */
  const showAppBar = !isEditing && !isPreview && !isConstructorHome;

  return (
    <Box
      sx={{
        minHeight: isFullHeight ? undefined : '100vh',
        height: isFullHeight ? '100vh' : undefined,
        overflow: isFullHeight ? 'hidden' : undefined,
        display: isFullHeight ? 'flex' : undefined,
        flexDirection: isFullHeight ? 'column' : undefined,
        bgcolor: isSmsLight ? SMS_PAGE.bg : 'background.default',
      }}
    >
      {showAppBar && (
        <AppBar
          component="header"
          className="header"
          position="static"
          elevation={0}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            minHeight: 58,
            '& .MuiToolbar-root': { minHeight: 58, py: 0 },
          }}
        >
          <Toolbar disableGutters sx={{ px: 2, gap: 1 }}>
            <SmsCabinetBackButton inverted />
            <Typography variant="h6" component="span" sx={{ flexGrow: 1, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
              Telegram Bot Constructor
            </Typography>
            <ThemeSelector inverted />
            <LanguageSelector inverted />
          </Toolbar>
        </AppBar>
      )}
      <Container
        maxWidth={isFullHeight || isConstructorHome ? false : 'xl'}
        disableGutters={isFullHeight || isConstructorHome}
        sx={{
          py: isFullHeight || isConstructorHome ? 0 : 2,
          flex: isFullHeight ? 1 : undefined,
          minHeight: isFullHeight ? 0 : undefined,
          overflow: isFullHeight ? 'hidden' : undefined,
          display: isFullHeight ? 'flex' : undefined,
          flexDirection: isFullHeight ? 'column' : undefined,
        }}
      >
        <Outlet />
      </Container>
    </Box>
  );
};

export default MainLayout;
